import { Box, Button, Modal, ModalClose, ModalDialog, Stack, Typography } from '@mui/joy';

const dialogSx = {
    width: 'calc(100vw - 32px)', maxWidth: 460, maxHeight: 'calc(100dvh - 32px)',
    overflowY: 'auto', bgcolor: 'var(--joy-palette-background-surface)',
    border: '1px solid var(--joy-palette-divider)', borderRadius: 'var(--joy-radius-xl)',
    p: { xs: 2, sm: 2.5 },
};
const rubles = value => Number(value || 0).toLocaleString('ru-RU', { maximumFractionDigits: 2 });
function deliveryLabel(status) {
    if (!status) return null;
    if (status.state === 'sent') return 'Уведомление передано push-сервису';
    if (status.state === 'queued' || status.state === 'sending') return 'Уведомление в очереди отправки';
    if (status.reason === 'no_subscription') return 'Нет активной подписки на уведомления';
    if (status.reason === 'disabled' || status.reason === 'muted') return 'Уведомления отключены у сотрудника';
    if (status.reason === 'inactive') return 'Аккаунт сотрудника неактивен';
    return 'Уведомление не отправлено — проверьте настройки push';
}

export function FineKindPicker({ open, onClose, onChoose }) {
    return <Modal open={open} onClose={onClose}><ModalDialog sx={dialogSx}>
        <ModalClose />
        <Typography level="h4" sx={{ pr: 4 }}>Что добавить?</Typography>
        <Stack spacing={1.5} sx={{ mt: 1 }}>
            <Button color="danger" size="lg" onClick={() => onChoose('fine')}>Штраф</Button>
            <Button color="warning" size="lg" onClick={() => onChoose('deduction')}>Списание</Button>
        </Stack>
    </ModalDialog></Modal>;
}

export function FineCreationResult({ items, onClose, onDelete }) {
    if (!items?.length) return null;
    const first = items[0];
    const total = items.reduce((sum, item) => sum + Math.round(Number(item.value) * 100), 0) / 100;
    return <Modal open onClose={onClose}><ModalDialog sx={dialogSx}>
        <ModalClose />
        <Typography level="h4" sx={{ pr: 4 }}>{first.is_deduction ? 'Списание добавлено' : 'Штраф добавлен'}</Typography>
        <Typography>Сотрудников: {items.length} · Всего: {rubles(total)} ₽</Typography>
        <Typography level="body-sm">{first.location_name} · {first.date?.split('-').reverse().join('.')}</Typography>
        <Typography sx={{ overflowWrap: 'anywhere' }}>{first.reason}</Typography>
        <Stack spacing={1} sx={{ my: 1 }}>
            {items.map(item => <Box key={item.id} sx={{ p: 1.5, border: '1px solid var(--joy-palette-divider)', borderRadius: 'var(--joy-radius-md)' }}>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <Typography fontWeight="lg" sx={{ minWidth: 0, overflowWrap: 'anywhere' }}>{item.photographer_name}</Typography>
                    <Typography color="danger" fontWeight="lg" sx={{ flexShrink: 0 }}>−{rubles(item.value)} ₽</Typography>
                </Box>
                <Typography level="body-xs">{item.is_administrator ? 'Как администратору' : 'Как фотографу'}</Typography>
                {deliveryLabel(item.notification_status) && <Typography level="body-xs" sx={{ mt: 0.5 }}>{deliveryLabel(item.notification_status)}</Typography>}
            </Box>)}
        </Stack>
        <Stack direction="row" spacing={1} justifyContent="flex-end">
            {items.length === 1 && onDelete && <Button color="danger" variant="soft" onClick={() => onDelete(first.id)}>Удалить</Button>}
            <Button onClick={onClose}>Закрыть</Button>
        </Stack>
    </ModalDialog></Modal>;
}
